import React, { useCallback, useState, useEffect } from "react";
import { Row, Col, OverlayTrigger, Tooltip, Form, Dropdown, Alert } from "react-bootstrap";
import DataTable from "react-data-table-component";
import { BsArrowDown, BsFillArrowLeftSquareFill, BsFileEarmarkCheck } from "react-icons/bs"; // BsDownload,
import { MdDelete } from "react-icons/md";
import { FaFileAlt } from "react-icons/fa";
import { toast } from "react-toastify";
import ButtonPermission from "../../../components/UI/Button/ButtonPermission";
import funcionalidades from "../../../context/AuthContext.funcionalidades";
import TextSpinner from "../../../components/UI/Spinner/TextSpinner";
import HtmlToString from "../../../components/Formatters/HtmlToString";
import ButtonImagePermission from "../../../components/UI/Button/ButtonImagePermission";
import FormOcorrenciasAF from "./FormOcorrenciasAF";
import useApiClient, { apiRoutes } from "../../../hooks/apiClient";
import EfisModal from "../../../components/UI/EfisModal/EfisModal";
import useGerarRelatoriosOcorrencia from "./hooks/useGerarRelatoriosOcorrencia";
import useDocumentos from "./hooks/useDocumentos";
import useVerificaResultado from "./hooks/useVerificaResultado";

import constants from "../../Constants";

const removeCell = (row, setShowExcluirConfirm, existe) => (
  <ButtonImagePermission
    permission={funcionalidades.ocorrencia.inserir}
    className="btn-lg text-danger pa-0 p-0"
    disabled={existe === "S"}
    onClick={() =>
      setShowExcluirConfirm({
        show: true,
        body: `Deseja remover a ocorrência ${row.sequencialTpOcorrencia}?`,
        context: row.sequencial,
      })
    }
    buttonImage={
      <MdDelete
        className="btn-lg text-orange p-0 btn btn-bg-transparent"
        style={{ fontSize: "20px" }}
        title="Excluir"
        disabled={existe === "S"}
      />
    }
    tooltipImage="Remover Ocorrência"
  />
);

const exibirDocumento = { exibir: () => {} };

const tipoDocumento = (dadosOs, tipo) => {
  exibirDocumento.exibir(dadosOs, tipo);
};

const showAcoes = (dadosOs) => (
  <>
    <OverlayTrigger placement="top" overlay={<Tooltip>Resumo da Ocorrência</Tooltip>}>
      <FaFileAlt
        className="text-primary"
        title="Resumo da Ocorrência"
        style={{ cursor: "pointer", marginRight: "8px", fontSize: "17px" }}
        onClick={() => tipoDocumento(dadosOs, "Resumo")}
      />
    </OverlayTrigger>{" "}
    <OverlayTrigger placement="top" overlay={<Tooltip>Demonstrativo de Ocorrência</Tooltip>}>
      <BsFileEarmarkCheck
        className="text-primary"
        title="Demonstrativo da Ocorrência"
        style={{ cursor: "pointer", fontSize: "17px" }}
        onClick={() => tipoDocumento(dadosOs, "Demonstrativo")}
      />
    </OverlayTrigger>
  </>
);

const columns = [
  {
    name: "",
    selector: "sequencialLinha",
    center: true,
    // sortable: true,
    maxWidth: "5%",
  },
  {
    name: "Tipo",
    selector: "sequencialTpOcorrencia",
    center: true,
    // sortable: true,
    maxWidth: "5%",
  },

  {
    name: "Descrição",
    cell: (row) => <HtmlToString html={row.descricao} />,
    center: false,
    maxWidth: "50%",
  },
  {
    name: "ICMS",
    cell: (row) =>
      row.valorIcms
        ? row.valorIcms.toLocaleString("pt-BR", { minimumFractionDigits: 2, maximumFractionDigits: 2 })
        : (0).toLocaleString("pt-BR", { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
    center: true,
    maxWidth: "10%",
  },
  {
    name: "Multa",
    cell: (row) =>
      row.valorMulta
        ? row.valorMulta.toLocaleString("pt-BR", { minimumFractionDigits: 2, maximumFractionDigits: 2 })
        : (0).toLocaleString("pt-BR", { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
    center: true,
    maxWidth: "10%",
  },
  {
    name: "Total",
    cell: (row) =>
      row.valorTotal
        ? row.valorTotal.toLocaleString("pt-BR", { minimumFractionDigits: 2, maximumFractionDigits: 2 })
        : (0).toLocaleString("pt-BR", { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
    center: true,
    maxWidth: "10%",
  },
];

const ConsultaOcorrenciaAF = ({ dadosOs, history }) => {
  const [totalRows] = useState(0);
  const setPageSize = useState(25)[1];
  const setPageNumber = useState(1)[1];
  const [mostrarTela, setMostrarTela] = useState(false);
  const [tipoTela, setTipoTela] = useState("");
  const [itemOcorrencia, setItemOcorrencia] = useState({});
  const [mostrarTelaOcafItem, setMostrarTelaOcafItem] = useState(false);
  const [titulo, setTitulo] = useState("Ocorrências da Ação Fiscal");
  const { request: requestOcorrencia, data: dataOcorrencia } = useApiClient();
  const [show, setShow] = useState(false);
  const { location } = history;
  const { pathname } = location;

  const caminho = pathname === "/app/os/consultarOs/consulta";

  const { verificaResultado, existe } = useVerificaResultado({ sqAcaoFiscal: dadosOs.acaoFiscal });

  useEffect(() => {
    if (dadosOs.acaoFiscal !== null && dadosOs.acaoFiscal !== "") {
      verificaResultado();
    }
  }, [dadosOs.acaoFiscal, verificaResultado]);

  const [showExcluirConfirm, setShowExcluirConfirm] = useState({
    show: false,
    body: null,
    context: null,
  });

  const { buscaDocumento } = useDocumentos();

  exibirDocumento.exibir = (dados, tipo) => {
    buscaDocumento(dados.acaoFiscal, dados.sequencial, tipo);
  };

  const handlePageChange = useCallback(
    (newPageNumber) => {
      setPageNumber(newPageNumber);
    },
    [setPageNumber],
  );

  const handlePerRowsChange = useCallback(
    (newPageSize) => {
      setPageSize(newPageSize);
      setPageNumber(1);
    },
    [setPageNumber, setPageSize],
  );

  useEffect(() => {
    if (mostrarTela) {
      if (tipoTela === "I") {
        setTitulo("Incluir Nova Ocorrência");
      } else {
        setTitulo("Alterar Ocorrência");
      }
    } else {
      setTitulo("Ocorrências da Ação Fiscal");
    }
  }, [mostrarTela, setTitulo, mostrarTelaOcafItem, itemOcorrencia, tipoTela]);

  const abrirTela = (item) => {
    requestOcorrencia(apiRoutes.fiscalizacao.ocorrencia.consultarOcorrencia, {
      sqAcaoFiscal: dadosOs.acaoFiscal,
      sqItemOcorrencia: item.sequencial,
    });
    // incluir nova ocorrência ou alterar ocorrência
    setMostrarTela(true);
  };

  useEffect(() => {
    if (dataOcorrencia && dataOcorrencia.result) {
      setItemOcorrencia({ ...dataOcorrencia.result[0] });
    }
  }, [dataOcorrencia, setItemOcorrencia]);

  // ----- regarregar dados da OS
  const { request: consultaFormRequest, data: consultaFormData } = useApiClient();

  const carregarDadosOs = useCallback(
    (seq) => {
      consultaFormRequest(apiRoutes.fiscalizacao.ordemservico.consultaDadosOs, { sequencial: seq });
    },
    [consultaFormRequest],
  );

  // ----|

  const {
    request: deleteItemRequest,
    isLoading: deleteItemIsLoading,
    data: deleteItemData,
    errors: deleteItemErrors,
  } = useApiClient();

  useEffect(() => {
    if (!deleteItemData && !deleteItemErrors) return;

    if (deleteItemData) {
      toast.success("Item de Ocorrência excluído com sucesso.");
      carregarDadosOs(dadosOs.sequencial);
    }

    if (deleteItemErrors) {
      setShow(true);
    }

    setShowExcluirConfirm({ show: false });
  }, [deleteItemData, deleteItemErrors, setShowExcluirConfirm, dadosOs, carregarDadosOs]);

  useEffect(() => {
    if (consultaFormData) {
      setItemOcorrencia(consultaFormData.result.ocorrencias);
    } else {
      setItemOcorrencia(dadosOs?.ocorrencias);
    }
  }, [setItemOcorrencia, consultaFormData, dadosOs]);

  const handleCancelar = () => {
    setMostrarTela(false);
    setMostrarTelaOcafItem(false);
    carregarDadosOs(dadosOs.sequencial); // Recarrega os dados da OS ao sair do formulário
  };

  const getTotalRow = (data) => {
    if (!data || data.length === 0) return null;

    const totalRow = {
      sequencialLinha: "Total",
      sequencialTpOcorrencia: "",
      descricao: "",
      valorIcms: data.reduce((acc, row) => acc + (row.valorIcms || 0), 0),
      valorMulta: data.reduce((acc, row) => acc + (row.valorMulta || 0), 0),
      valorTotal: data.reduce((acc, row) => acc + (row.valorTotal || 0), 0),
      isTotalRow: true, // Flag para identificação
    };

    return totalRow;
  };

  const columnsWithActions = [
    ...columns,
    {
      name: "Ações",
      selector: "",
      width: "5%",
      center: true,
      cell: (row) =>
        row.isTotalRow ? (existe === "S" ? showAcoes(dadosOs) : "") : removeCell(row, setShowExcluirConfirm, existe),
      // cell: (row) => !row.isTotalRow && removeCell(row, setShowExcluirConfirm),
    },
  ];

  // Obtém os dados + linha de totalização
  const dataWithTotal = [...(itemOcorrencia?.length > 0 ? itemOcorrencia : dadosOs?.ocorrencias || [])];
  const totalRow = getTotalRow(dataWithTotal);
  if (totalRow) dataWithTotal.push(totalRow);

  const { handleImprimirResumo, handleImprimirDemonstrativo, isLoadingOcorrencia } = useGerarRelatoriosOcorrencia({
    dadosOs,
    itemOcorrencia,
  });

  const imprimirResumo = () => {
    handleImprimirResumo();
  };

  const imprimirDemonstrativo = () => {
    handleImprimirDemonstrativo();
  };

  return (
    <>
      <EfisModal
        show={showExcluirConfirm.show}
        body={showExcluirConfirm.body}
        loadingConfirmationAction={deleteItemIsLoading}
        closeHandler={() => setShowExcluirConfirm({ show: false })}
        confirmationHandler={() => {
          const params = {
            sqAcaoFiscal: dadosOs.acaoFiscal,
            sqItemOcorrencia: showExcluirConfirm.context,
          };
          deleteItemRequest(apiRoutes.fiscalizacao.ocorrencia.excluirItemOcorrencia, params);
        }}
      />
      <div style={{ width: "100%" }}>
        <div className="pt-3pb-0 flex-row w-100">
          <Form.Group as={Row} className="d-flex flex-row mb-3">
            <Col classeName="form-inline justify-content-start d-flex align-items-center">
              {mostrarTela && (
                <OverlayTrigger placement="top" overlay={<Tooltip>Voltar tela ocorrências</Tooltip>}>
                  <BsFillArrowLeftSquareFill
                    size="20"
                    color="#E37023"
                    onClick={() => {
                      setMostrarTela(false);
                      setMostrarTelaOcafItem(false);
                      carregarDadosOs(dadosOs.sequencial);
                    }}
                    className="mr-3"
                  />
                </OverlayTrigger>
              )}

              <span className="font-weight-bold text-primary">{titulo}</span>
            </Col>

            {!mostrarTela ? (
              <Col className="form-inline justify-content-end">
                <>
                  {dadosOs?.siglaTipoAcaoFiscal !== "ROTDIL" && dadosOs?.siglaTipoAcaoFiscal !== "MONIT" && (
                    <ButtonPermission
                      className="mr-0 btn btn-primary btn-md btn-user mx-4"
                      name="Nova Ocorrência"
                      permission={funcionalidades.ocorrencia.consultaDadosOcorrencias}
                      onClick={() => {
                        setMostrarTela(true);
                        setTipoTela("I");
                      }}
                      disable={existe === "S" || caminho}
                    />
                  )}

                  {dadosOs?.ocorrencias && (
                    <Dropdown className="d-flex flex-row">
                      <Dropdown.Toggle
                        variant="primary"
                        className="btn-md"
                        id="dropdown-basic"
                        disabled={isLoadingOcorrencia}
                      >
                        {isLoadingOcorrencia ? (
                          <>
                            <span
                              className="spinner-border spinner-border-sm mr-2"
                              role="status"
                              aria-hidden="true"
                            ></span>
                            Gerando pdf...
                          </>
                        ) : (
                          "Gerar"
                        )}
                      </Dropdown.Toggle>
                      <Dropdown.Menu>
                        <Dropdown.Item onClick={() => imprimirDemonstrativo()}>
                          Demonstrativo de Ocorrência
                        </Dropdown.Item>
                        <Dropdown.Item onClick={() => imprimirResumo()}>Resumo de Ocorrência</Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown>
                  )}
                </>
              </Col>
            ) : (
              ""
            )}
          </Form.Group>
        </div>
        {!mostrarTela ? (
          <>
            <Alert variant="danger" show={show} onClose={() => setShow(false)} dismissible>
              {" "}
              {deleteItemErrors?.message}{" "}
            </Alert>
            <Row>
              <Col>
                <DataTable
                  noHeader
                  keyField="sequencial"
                  columns={columnsWithActions}
                  data={dataWithTotal}
                  noDataComponent="Esta Ação Fiscal não possui ocorrências."
                  progressComponent={<TextSpinner />}
                  defaultSortFieldId={1}
                  sortIcon={<BsArrowDown />}
                  pagination
                  sortable
                  paginationTotalRows={totalRows}
                  selectableRows={false}
                  pointerOnHover
                  onRowClicked={(row) => {
                    if (row.sequencialLinha !== "Total") {
                      abrirTela(row);
                      setTipoTela("A");
                    }
                  }}
                  onChangeRowsPerPage={handlePerRowsChange}
                  onChangePage={handlePageChange}
                  paginationComponentOptions={constants.paginationComponentOptions}
                  paginationPerPage={25}
                  expandableRows={false}
                  conditionalRowStyles={[
                    {
                      when: (row) => row.isTotalRow,
                      style: {
                        fontWeight: "bold",
                        backgroundColor: "#f4f4f4",
                        cursor: "not-allowed",
                      },
                    },
                  ]}
                />
              </Col>
            </Row>{" "}
          </>
        ) : (
          ""
        )}
        {mostrarTela && (
          <Row>
            <Col>
              <FormOcorrenciasAF
                history={history}
                dadosOs={dadosOs}
                dadosOcorrencia={itemOcorrencia}
                onCancelar={handleCancelar}
                tipoTela={tipoTela}
              />
            </Col>
          </Row>
        )}
      </div>
    </>
  );
};

export default ConsultaOcorrenciaAF;
